var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.744 37.4981L72.144 9.35819M72.144 9.35819L60.104 5M72.144 9.35819L67.664 20.9262M75 75H61V37.3367C61 36.6232 61.295 35.9389 61.8201 35.4344C62.3452 34.9299 63.0574 34.6464 63.8 34.6464H72.2C72.9426 34.6464 73.6548 34.9299 74.1799 35.4344C74.705 35.9389 75 36.6232 75 37.3367V75ZM47 75H33V45.4074C33 44.6939 33.295 44.0096 33.8201 43.5051C34.3452 43.0006 35.0574 42.7171 35.8 42.7171H44.2C44.9426 42.7171 45.6548 43.0006 46.1799 43.5051C46.705 44.0096 47 44.6939 47 45.4074V75ZM19 75H5V53.4781C5 52.7646 5.295 52.0803 5.8201 51.5758C6.3452 51.0713 7.05739 50.7879 7.8 50.7879H16.2C16.9426 50.7879 17.6548 51.0713 18.1799 51.5758C18.705 52.0803 19 52.7646 19 53.4781V75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.f012ba2ba8e92eba75130f8fbc46607f.svg";
export { ForwardRef as ReactComponent };